module.exports = "<svg #chart></svg>\r\n";